export interface ActionMeta {
  label: string;
  icon: string;
  tone: string;
}

/** Metadatos visuales por tipo de acción registrada. */
export const ACTION_META: Record<string, ActionMeta> = {
  crear: { label: "Crear", icon: "ri-add-circle-line", tone: "bg-accent-100 text-accent-800" },
  editar: { label: "Editar", icon: "ri-edit-2-line", tone: "bg-secondary-100 text-secondary-800" },
  eliminar: { label: "Eliminar", icon: "ri-delete-bin-6-line", tone: "bg-primary-100 text-primary-700" },
  anular: { label: "Anular", icon: "ri-close-circle-line", tone: "bg-primary-100 text-primary-700" },
  reembolsar: { label: "Reembolsar", icon: "ri-refund-2-line", tone: "bg-primary-100 text-primary-700" },
  inventario: { label: "Inventario", icon: "ri-stack-line", tone: "bg-secondary-100 text-secondary-800" },
  configurar: { label: "Configurar", icon: "ri-settings-3-line", tone: "bg-background-200 text-foreground-700" },
  abrir_caja: { label: "Abrir caja", icon: "ri-lock-unlock-line", tone: "bg-secondary-100 text-secondary-800" },
  movimiento_caja: { label: "Movimiento de caja", icon: "ri-exchange-dollar-line", tone: "bg-secondary-100 text-secondary-800" },
  cerrar_caja: { label: "Cerrar caja", icon: "ri-lock-line", tone: "bg-secondary-100 text-secondary-800" },
  suspender_venta: { label: "Suspender venta", icon: "ri-pause-circle-line", tone: "bg-background-200 text-foreground-700" },
};

const DEFAULT_META: ActionMeta = {
  label: "Acción",
  icon: "ri-history-line",
  tone: "bg-background-200 text-foreground-700",
};

export function getActionMeta(action: string | null | undefined): ActionMeta {
  if (!action) return DEFAULT_META;
  return ACTION_META[action] ?? { ...DEFAULT_META, label: action };
}

/** Nombre legible por entidad afectada. */
export const ENTITY_LABELS: Record<string, string> = {
  branches: "Sucursales",
  profiles: "Perfiles",
  users: "Usuarios",
  products: "Productos",
  product_categories: "Categorías",
  brands: "Marcas",
  inventory: "Inventario",
  inventory_movements: "Movimientos de inventario",
  customers: "Clientes",
  customer_vehicles: "Vehículos",
  services: "Servicios",
  offers: "Ofertas",
  invoices: "Facturas",
  sales: "Ventas",
  cash_registers: "Cajas",
  cash_movements: "Movimientos de caja",
  cash_closings: "Cierres de caja",
  held_sales: "Ventas suspendidas",
  app_settings: "Configuración general",
  catalog_settings: "Configuración del catálogo",
  invoice_settings: "Configuración de facturas",
  printer_settings: "Configuración de impresoras",
  shortcuts: "Atajos del POS",
};

export function getEntityLabel(entity: string | null | undefined): string {
  if (!entity) return "—";
  return ENTITY_LABELS[entity] ?? entity;
}

export const ACTION_OPTIONS: { value: string; label: string }[] = Object.entries(ACTION_META).map(
  ([value, meta]) => ({ value, label: meta.label }),
);

export const ENTITY_OPTIONS: { value: string; label: string }[] = Object.entries(ENTITY_LABELS)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => a.label.localeCompare(b.label));

/** Abrevia un identificador largo para mostrarlo en la lista. */
export function shortId(id: string | null | undefined): string {
  if (!id) return "—";
  if (id.length <= 14) return id;
  return `${id.slice(0, 8)}…${id.slice(-4)}`;
}